import Home from "../../pages/LandingPage/Home/Home";
import LandingPageLayout from "../../layouts/LandingPage/LandingPageLayout";
import Buy from "../../pages/LandingPage/Buy/Buy";
import Sell from "../../pages/LandingPage/Sell/Sell";
import Finance from "../../pages/LandingPage/Finance/Finance";
import Trade from "../../pages/LandingPage/Trade/Trade";
import GetInstantCash from "../../pages/LandingPage/Sell/GetInstantCash/GetInstantCash";
import PropertySearch from "../../components/PropertySearch/PropertySearch";
import Learn from "../../pages/LandingPage/Learn/Learn";
import HubPreview from "../../pages/LandingPage/HubPreview/HubPreview";


// let propertySearchRoutes = {
//     "property.search": {
//         path: '/:clientSuffix/buy',
//         component: LandingPageLayout,
//         children: [
//             {
//                 path: '',
//                 props: true,
//                 name: 'property.search',
//                 component: PropertySearch,
//                 meta: {
//                     app: 'search-properties',
//                     layout: Buy,
//                 },
//             },
//         ]
//     },
//     "property.details.view": {
//         path: '/:clientSuffix/buy/property-details/:id',
//         component: LandingPageLayout,
//         children: [
//             {
//                 path: '/',
//                 name: 'property.details.page',
//                 component: PropertySearch,
//                 meta: {
//                     app: 'search-properties',
//                     layout: Buy,
//                 },
//             },
//         ]
//     },
// };
//
// export {propertySearchRoutes};

let propertySearchRoutes = {
    path: '/:organizationSlug/:clientSuffix',
    "property.search": {
        path: '/:orgSlug/:userSlug/:clientSuffix/buy',
        component: LandingPageLayout,
        children: [
            {
                path: '',
                props: true,
                name: 'property.search',
                component: PropertySearch,
                meta: {
                    app: 'search-properties',
                    layout: Buy,
                },
            },
        ]
    },
    "property.details.view": {
        path: '/:orgSlug/:userSlug/:clientSuffix/buy/property-details/:id',
        component: LandingPageLayout,
        children: [
            {
                path: '/',
                name: 'property.details.page',
                component: PropertySearch,
                meta: {
                    app: 'search-properties',
                    layout: Buy,
                },
            },
        ]
    },
};

export {propertySearchRoutes};

export default {
    path: '/:orgSlug/:userSlug/:clientSuffix',
    name: 'landing-page.index',
    component: LandingPageLayout,
    redirect: {name: 'landing-page.home'},
    children: [
        {
            path: 'home',
            name: 'landing-page.home',
            component: Home

        },
        {
            path: 'buy',
            name: 'landing-page.buy',
            component: Buy,
            children: [
                {
                    path: 'buy',
                    props: true,
                    name: 'property.search',
                    component: PropertySearch,
                    meta: {
                        app: 'search-properties',
                    },
                },
                {
                    path: 'property-details/:id',
                    name: 'property.details.page',
                    component: PropertySearch,
                    meta: {
                        app: 'search-properties'
                    },
                }
            ]
        },
        {
            path: 'sell',
            name: 'landing-page.sell',
            component: Sell,
            children: [
                {
                    path: 'get-instant-cash',
                    name: 'landing-page.sell.get-instant-cash',
                    component: GetInstantCash,
                }
            ]
        },
        {
            path: 'finance',
            name: 'landing-page.finance',
            component: Finance
        },
        {
            path: 'refinance',
            name: 'landing-page.refinance',
            component: Finance
        },
        {
            path: 'trade-in',
            name: 'landing-page.trade',
            component: Trade
        },
        {
            path: 'learn',
            name: 'landing-page.learn',
            component: Learn
        },
        {
            path: 'hub-preview',
            name: 'landing-page.hub-preview',
            component: HubPreview
        },
    ]
};
